import init from './steps/init';
import chooseChannel, { REDIRECT_SUCCESS } from './steps/chooseChannel';
import requestNewChannel from './steps/requestNewChannel';
import requestResend from './steps/requestResend';
import submitCode from './steps/submitCode';
import abandon from './steps/abandon';

const authTree = {
  init,
  chooseChannel,
  submitCode,
  requestResend,
  requestNewChannel,
  abandon,
};

export { REDIRECT_SUCCESS };
export default authTree;
